import React from 'react';

const Delaware = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Delaware Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>Comprehensive disclosure form with 200 questions required.</li>
        <li>
          Seller’s Disclosure of Real Property Condition Report: Required.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/Delaware-Sellers-Disclosure-Report-New-Construction.pdf',
                '_blank'
              );
            }}
          >
            New Construction Property Disclosure Form{' '}
          </span>{' '}
          – This form covers all potential issues and conditions that may affect
          the value of the property. It should be used for newly constructed
          properties.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/Delaware-Sellers-Disclosure-Report.pdf',
                '_blank'
              );
            }}
          >
            Standard Property Disclosure Form{' '}
          </span>{' '}
          – The State of Delaware requires all sellers of residential property
          to disclose any material defects known to them when the property is
          put up for sale.
        </li>
      </ol>
    </div>
  );
};

export default Delaware;
